import MicroModal from 'micromodal';

(function () {
  const loginForm = document.querySelector('#trade-login');

  function handleLoginSubmit(event) {
    event.preventDefault();
    const input = loginForm.querySelector('#email') as HTMLInputElement;

    // THIS IS JUST DUMMY TO SHOW DIFFERENT STATES AND WILL NEED UPDATING TO WORK WITH API

    // Account not found
    if (input.value === 'notfound@test.com') {
      MicroModal.show('account-not-found');
    }

    // Activate account
    if (input.value === 'activate@test.com') {
      MicroModal.show('activate');
    }

    // Activate account
    if (input.value === 'access-request@test.com') {
      MicroModal.show('access-request');
    }
  }

  if (loginForm) {
    loginForm.addEventListener('submit', handleLoginSubmit);
  }
})();
